<template>
  <div class="a-product-option-bundle" :id="'bundleOption_' + option.option_id" v-show="isSelectable">
    <SfAlert
      v-if="errorMessage"
      :message="errorMessage"
      type="danger"
    />
    <SfHeading
      :title="option.title + ' anpassen'"
      :level="4"
      class="sf-heading--left"
    />

    <div class="product-boxes-items">
      <ABundleRadio
        v-for="link in sortedProducts"
        :key="link.id"
        :label="link.product && link.product.name"
        :name="link.product && link.product.name"
        :value="String(link.id)"
        :selected="selectedProductOptionId"
        @input="onProductOptionInput"
      >
        <template #label="{label}">
          <SfImage :src="getThumbnailForProduct(link.product)" v-if="link.product" />

          <div class="label product-boxes-item-content" v-if="link.product">
            <div class="sf-radio__label">
              {{ label }}
            </div>

            <div class="product-boxes-item-remove">entfernen</div>
            <div class="product-boxes-item-select">auswählen</div>

            <a-product-base-price
              :regular="link.price < link.product.final_price_incl_tax.toFixed(2) ? link.product.final_price_incl_tax.toFixed(2) : link.price"
              :special="link.price < link.product.final_price_incl_tax.toFixed(2) ? link.price : null"
              :factor="link.product.baseprice_product_amount"
              :unit="link.product.baseprice_product_unit"
            />

            <div
              v-if="link.price === 0"
              class="badge badge-free"
            >
              kostenlos
            </div>
          </div>
        </template>
        <template #description>
          <div class="hidden" />
        </template>
      </ABundleRadio>
    </div>
  </div>
</template>

<script>
import MProductOptionBundle from 'theme/components/molecules/m-product-option-bundle'
import ABundleRadio from 'theme/components/atoms/a-bundle-radio'
import AProductBasePrice from 'theme/components/atoms/a-product-base-price'

import { SfAlert, SfImage } from '@storefront-ui/vue';
import { getThumbnailForProduct } from '@vue-storefront/core/modules/cart/helpers';
import { mapGetters } from 'vuex';

import { basePriceUnit } from 'theme/helpers/custom';

export default {
  mixins: [MProductOptionBundle],
  name: 'MProductOptionBundleRz',
  components: {
    SfAlert,
    SfImage,
    ABundleRadio,
    AProductBasePrice
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    isSelectable () {
      return this.option.product_links.length > 1 || 
        !this.option.required
    },
    sortedProducts () {
      return this.option.product_links.slice().sort((a, b) => a.position - b.position)
    },
    selectedProductOptionId () {
      return this.productOptionId === null || this.productOptionId === undefined
        ? ''
        : String(this.productOptionId)
    }
  },
  methods: {
    getThumbnailForProduct (product) {
      return getThumbnailForProduct(product);
    },
    onProductOptionInput (value) {
      this.productOptionId = value === '' ? null : Number(value)
    },
    basePriceUnit (product) {
      return basePriceUnit(product)
    }
  }
};
</script>
